export const selectContacts = (state) => state.businessDirectory.rows;

export const selectContactsHasMore = (state) => state.businessDirectory.hasMore;

export const selectContactsLoading = (state) => state.businessDirectory.loading;

export const selectContactsError = (state) => state.businessDirectory.error;

export const selectContactFilters = (state) => state.businessDirectory.filters;
